import { createContext, useContext } from "react";

interface DocumentFieldsContextValue {
  setTierIdWithGuard: (newTierId: string) => void;
}

export const DocumentFieldsContext =
  createContext<DocumentFieldsContextValue | null>(null);

export const useDocumentFieldsContext = (): DocumentFieldsContextValue => {
  const context = useContext(DocumentFieldsContext);

  if (!context) {
    throw new Error("Document fields must be used within DocumentFieldsGuard");
  }

  return context;
};
